// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"dc6f842c","787":"13e3e0c6"}[chunkId] + ".chunk.js";
};